// copy-coupon.js
(function() {
  // Utility: copy text with fallback
  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    } else {
      // fallback
      return new Promise(function(resolve, reject) {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        try {
          var ok = document.execCommand('copy');
          document.body.removeChild(ta);
          ok ? resolve() : reject(new Error('execCommand failed'));
        } catch (e) {
          document.body.removeChild(ta);
          reject(e);
        }
      });
    }
  }

  // Create styled button element
  function createButton() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'copy-coupon-btn';
    btn.setAttribute('aria-label', 'Copy coupon code');
    btn.textContent = 'Copy';
    // Basic inline styles you can later move to CSS
    btn.style.marginLeft = '8px';
    btn.style.padding = '4px 8px';
    btn.style.cursor = 'pointer';
    btn.style.border = '1px solid rgba(0,0,0,0.1)';
    btn.style.background = 'white';
    btn.style.borderRadius = '4px';
    btn.style.fontSize = '13px';
    return btn;
  }

  // Try to find the coupon and attach button
  function attachIfFound(root) {
    root = root || document;
    // Several selector attempts to match where your offer content might render
    var selectors = [
      '.offers p',                 // suggested earlier
      '.product-offers p',         // alternate
      '.product__offers p',        // theme variants
      '.rte p',                    // rich text areas
      '.product-single__meta p'    // another common PDP selector
    ];

    for (var s = 0; s < selectors.length; s++) {
      var para = root.querySelector(selectors[s]);
      if (!para) continue;

      // find a <strong> with the coupon text like BLACKFRI15 OR just any <strong>
      var strongElements = para.querySelectorAll('strong');
      for (var i = 0; i < strongElements.length; i++) {
        var strong = strongElements[i];
        var text = strong.textContent && strong.textContent.trim();
        if (!text) continue;

        // If you want to limit to a specific code, check it here:
        // if (text !== 'BLACKFRI15') continue;

        // avoid adding multiple buttons
        if (strong.nextElementSibling && strong.nextElementSibling.classList &&
            strong.nextElementSibling.classList.contains('copy-coupon-btn')) {
          continue;
        }

        var btn = createButton();
        btn.addEventListener('click', function(code, el) {
          return function() {
            copyText(code).then(function() {
              // give visual feedback
              var prev = el.textContent;
              btn.textContent = 'Copied!';
              setTimeout(function() { btn.textContent = 'Copy'; }, 1800);
            }).catch(function(err) {
              console.error('Copy failed', err);
              // fallback: select the text for manual copy
              alert('Could not copy automatically. Please select and copy: ' + code);
            });
          };
        }(text, strong));
        strong.parentNode.insertBefore(btn, strong.nextSibling);
      }

      // stop after first matching paragraph to avoid duplicate buttons
      return true;
    }

    return false;
  }

  // If content is rendered later (Shopify sections), observe DOM changes and attach when available
  function observeAndAttach() {
    // If already present, just attach
    if (attachIfFound(document)) return;

    var obs = new MutationObserver(function(mutations, observer) {
      if (attachIfFound(document)) {
        observer.disconnect();
      }
    });

    obs.observe(document.documentElement || document.body, {
      childList: true,
      subtree: true
    });

    // safety timeout: give up after 10s
    setTimeout(function() { obs.disconnect(); }, 10000);
  }

  // Run when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAndAttach);
  } else {
    observeAndAttach();
  }
})();
